import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import type { ConversationContactRole } from '../../../lib/types';

/**
 * useContactRole — Item 391-D. Busca o papel do contato na conversa
 * (titular/autorizado/dependente/relacionado) sob demanda — só quando o
 * IdentityPopover está aberto E a conversa tem vínculo (`enabled`). Read-only,
 * gate backend `person-read`. Stale 60s (papel muda raramente numa sessão).
 */
export function useContactRole(
  conversationId: string,
  enabled: boolean,
): { data: ConversationContactRole | undefined; isLoading: boolean } {
  const query = useQuery({
    queryKey: ['contact-role', conversationId],
    queryFn: () => api.getContactRole(conversationId),
    enabled,
    staleTime: 60_000,
    retry: false,
  });
  return { data: query.data, isLoading: query.isLoading };
}
